import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserRole } from '../../hooks/useUserRole';

/**
 * HomePage component that redirects users to their default page based on role
 * - Administrator/Supervisor users → redirected to /reports
 * - Regular users → redirected to /grab-shift
 */
const HomePage: React.FC = () => {
    const navigate = useNavigate();
    const { isHROrManager, isLoading } = useUserRole();

    useEffect(() => {
        // Wait for role to be determined
        if (isLoading) return;

        // Redirect based on user role
        if (isHROrManager) {
            // HR/Manager users (Administrator/Supervisor) see Reports as default
            navigate('/reports', { replace: true });
        } else {
            // Regular users see Grab Shift as default
            navigate('/grab-shift', { replace: true });
        }
    }, [isHROrManager, isLoading, navigate]);

    // Optionally show a loading state while redirecting
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
        }}>
            <p>Loading...</p>
        </div>
    );
};

export default HomePage;